import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltyFeatureControlService } from '../novelty-feature-control-service';
import { SharePageService } from '@/services/share-page/share-page-service';


@injectable()
export class NoveltyFeatureControlServiceImpl implements NoveltyFeatureControlService {
    constructor(
        @inject(SharePageService)
        private readonly _sharePageService: SharePageService,
    ) { }

    get isPatentAdditionEnabled(): boolean {
        return !this._sharePageService.isSharePage;
    }

    get isPatentDetailViewEnabled(): boolean {
        return !this._sharePageService.isSharePage;
    }

    get isComparativeLiteratureEditEnabled(): boolean {
        return !this._sharePageService.isSharePage;
    }

    get isFeedbackEnabled(): boolean {
        return !this._sharePageService.isSharePage;
    }

    get isExportEnabled(): boolean {
        return !this._sharePageService.isSharePage;
    }
}
